import { render, staticRenderFns } from "./ServicosOrdemServicoNew.vue?vue&type=template&id=7d9d31eb&scoped=true&"
import script from "./ServicosOrdemServicoNew.vue?vue&type=script&lang=js&"
export * from "./ServicosOrdemServicoNew.vue?vue&type=script&lang=js&"
import style0 from "./ServicosOrdemServicoNew.vue?vue&type=style&index=0&id=7d9d31eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9d31eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
